(() => {
  const mapUrl = window.AperigustoCatalogContentMapUrl;
  if (!mapUrl) return;

  const language = (document.documentElement.lang || 'it').toLowerCase();
  const labels = language.startsWith('en')
    ? { contents: 'Contents', each: ' each' }
    : language.startsWith('de')
      ? { contents: 'Inhalt', each: ' je Stück' }
      : { contents: 'Contenuto', each: ' ciascuno' };
  const singlePacks = new Set(['BLK', 'ZIP', 'CCL']);

  fetch(mapUrl, { credentials: 'same-origin' })
    .then((response) => response.ok ? response.json() : Promise.reject(new Error(`content map ${response.status}`)))
    .then((contentBySku) => {
      document.querySelectorAll('[data-aperigusto-content-sku]').forEach((element) => {
        const content = contentBySku[element.dataset.aperigustoContentSku];
        if (!content) return;
        const each = singlePacks.has(element.dataset.aperigustoPackCode) ? '' : labels.each;
        element.textContent = `${labels.contents}: ${content}${each}`;
      });
    })
    .catch(() => {
      // Fail closed: never expose Shopify shipping weight as a consumer-facing net content value.
    });
})();
